<template>
  <div class="trial-container">
    <div class="acdsx">
      <!-- 左侧介绍区 -->
      <div class="trial-intro">
        <div class="intro-content">
          <h1>中模·promold系统免费试用</h1>

          <div class="intro-desc">
            <span>
              　温州中模网络科技有限公司,自2015年成立以来,便深耕于模具行业的数字化解决方案领域，成为一家引领行业创新的高科技企业。
              　公司坐落于风景秀丽的浙江省乐清市精密模具产业园，依托地理优势与产业集聚效应，不断推动模具制造的智能化进程。
            </span>
            <br />&nbsp;
            <span>
              　中模科技凭借多年的技术积累与行业洞察,成功开发出了一套完整的模具全生命周期管理解决方案
              <span class="highlight">(中模·promold)</span>
              　该方案覆盖了模具项目管理的每一个环节，从模具设计、机加工流程管理到外协加工协调，再到模具台账与履历的精细管理，
              形成了一个闭环的管理体系。不仅如此，中模科技还进一步延伸服务范围，将冲压/注塑生产排程管理、车间管理等以模具为核心的生产管理系统纳入其中，
              为企业提供了一站式的数字化管理服务。
            </span>
          </div>

          <!-- 优势特点 -->
          <div class="trial-features">
            <div
              class="feature-item"
              v-for="(item, index) in features"
              :key="index"
            >
              <img :src="item.img" class="feature-icon" />
              <div class="feature-text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧表单区 -->
      <div
        class="trial-form-panel"
        v-if="!showSuccessPanel && !showErrorSuccessPanel"
      >
        <div
          type="text"
          icon="el-icon-arrow-left"
          @click="goBack"
          class="back-btn"
        >
          <img
            src="../../assets/mmsyimg.png"
            alt=""
            style="width: 16px; height: 16px"
          />
          回到首页
        </div>
        <h2>体验试用</h2>
        <p class="form-tip">提交后自动获得中模云试用账号（试用3天）</p>
        <el-form
          ref="trialForm"
          :model="form"
          :rules="rules"
          label-width="0"
          class="trial-form"
        >
          <el-form-item prop="companyName">
            <el-input
              v-model="form.companyName"
              placeholder="请输入企业名称"
              prefix-icon="el-icon-office-building"
              clearable
            />
          </el-form-item>

          <el-form-item prop="linkman">
            <el-input
              v-model="form.linkman"
              placeholder="请输入您的称呼"
              prefix-icon="el-icon-user"
              clearable
            />
          </el-form-item>

          <el-form-item prop="contactInfo">
            <el-input
              v-model="form.contactInfo"
              placeholder="请输入手机号"
              prefix-icon="el-icon-phone"
              clearable
              maxlength="11"
            />
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              class="submit-btn"
              @click="submitForm"
              style="color: #fff"
            >
              立即试用
            </el-button>
          </el-form-item>
        </el-form>

        <div class="form-footer">
          <p>无法注册？请联系售前顾问获取体验账号</p>
        </div>
        <div style="height: 58px"></div>
      </div>
      <!-- 注册成功 -->
      <div class="trial-form-panel2" v-if="showSuccessPanel">
        <div class="success-icon">
          <img src="../../assets/check.png" alt="" class="checkimg" />
        </div>
        <div class="account-info">
          <p>
            <strong style="color: #000a25"
              >体验账号：{{ accountData.phone || "" }}</strong
            >
            <strong style="color: #000a25; margin-left: 12px"
              >密码：{{ accountData.password || "" }}</strong
            >
          </p>
          <p class="expire-tip">
            体验账号有效期为3天，结束日期
            <i style="color: #005cef">{{ accountData.expireDate || "" }}</i>
            请及时登录体验
          </p>
        </div>
        <div class="btn-group">
          <div class="login-btn" @click="login">
            前往登录<span class="arrow"></span>
          </div>
          <div class="home-btn" @click="goBack">
            返回首页<span class="arrow"></span>
          </div>
        </div>
        <div style="height: 105px"></div>
      </div>
      <!-- 注册失败 -->
      <div class="trial-form-panel2 error" v-if="showErrorSuccessPanel">
        <div class="success-icon">
          <img src="../../assets/error.png" alt="" class="checkimg" />
        </div>
        <div class="account-infos">
          <p style="font-weight: 700; font-size: 16px">
            当前试用<i style="color: #005cef; font-weight: 700; font-size: 16px"
              >名额已满</i
            >，需添加请联系客服人员新增
          </p>
          <p class="expire-tips">
            <img
              src="../../assets/phones.png"
              alt=""
              style="width: 20px; height: 20px; margin-right: 5px"
            />
            <i style="font-weight: 400; font-size: 14px; color: #858a9d"
              >服务热线：</i
            ><i style="color: #005cef">0577-61318188</i>
          </p>
        </div>
        <div class="btn-group">
          <div class="home-btns" @click="goBack">
            返回首页<span class="arrow"></span>
          </div>
        </div>
        <div style="height: 132px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mmsy1 from "../../assets/mmsy1.png";
import mmsy2 from "../../assets/mmsy2.png";
import mmsy3 from "../../assets/mmsy3.png";
import mmsy4 from "../../assets/mmsy4.png";
import { freeSupplyInsert, verPhone } from "../../api/article";
export default {
  name: "TrialPage",
  data() {
    return {
      showErrorSuccessPanel: false,
      isPhoneVerified: false, // 接口是否成功
      phoneError: "", // 错误字段名（与prop一致）
      showSuccessPanel: false,
      // 新增：存储接口返回的账号密码
      accountData: {
        phone: "", // 体验账号
        password: "", // 密码
        expireDate: "",
      },
      // 表单数据
      form: {
        companyName: "",
        linkman: "",
        contactInfo: "",
      },
      // 表单验证规则
      rules: {
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        linkman: [
          { required: true, message: "请输入您的称呼", trigger: "blur" },
        ],
        contactInfo: [
          { required: true, validator: this.validatePass, trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号格式",
            trigger: "blur",
          },
        ],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { pattern: /^\d{6}$/, message: "验证码为6位数字", trigger: "blur" },
        ],
      },
      // 优势特点
      features: [
        { img: mmsy1, text: "一天即可上线" },
        { img: mmsy2, text: "优质技术支持" },
        { img: mmsy3, text: "专业级实施团队" },
        { img: mmsy4, text: "完整售后保障链" },
      ],
      // 验证码倒计时
      countdown: 0,
      // 定时器
      timer: null,
    };
  },
  methods: {
    async validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        const { code, message } = await verPhone({ phone: value });
        if (code == 0) {
          callback();
        } else {
          callback(new Error(message));
        }
      }
    },
    login() {
      window.location.href =
        this.$route.query.from === "yun"
          ? "https://yun.mould.cn/loginView.html"
          : "https://yun.mould.cn/yunLoginView";
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    // 提交表单
    submitForm() {
      this.$refs.trialForm.validate(async (valid) => {
        if (!valid) return;
        try {
          this.isSubmitting = true;
          const res = await freeSupplyInsert({
            companyName: this.form.companyName,
            linkman: this.form.linkman,
            contactInfo: this.form.contactInfo, // 手机号字段名需匹配后端
            // verifyCode: this.form.verifyCode
          });
          if (res.code == 0) {
            this.$message.success(
              "试用申请提交成功，我们将尽快为您开通试用账号！"
            );
            this.$refs.trialForm.resetFields();
            this.accountData.phone = res.data.phone;
            this.accountData.password = res.data.password;
            this.accountData.expireDate = res.data.expireDate;
            this.showSuccessPanel = true;
          } else if (res.code == 1) {
            this.showErrorSuccessPanel = true;
            this.$message.error(res.message || "提交失败，请重试");
          } else {
            this.$message.error(res.message || "提交失败，请重试");
          }
        } catch (error) {
          this.$message.error("提交失败，请检查网络或联系管理员");
          console.error("freeSupplyInsert 接口异常：", error);
        } finally {
          this.isSubmitting = false;
        }
      });
    },
  },
  beforeDestroy() {
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style scoped>
.trial-container {
  position: relative;
  height: 100vh;
  font-family: "Microsoft YaHei", sans-serif;
  background-color: #f3f7fc;
}

.acdsx {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 600px;
  width: 1200px;
  box-shadow: 0px 0px 99px 1px rgba(8, 43, 125, 0.16);
}

/* 左侧介绍区 */
.trial-intro {
  width: 50%;
  height: 100%;
  float: left;
  /* background: linear-gradient(135deg, #e6f7ff 0%, #f0faff 100%); */
  background-image: url("../../assets/mmsybackground.png");
  background-repeat: no-repeat; /* 防止背景图重复 */
  background-size: cover; /* 背景图自适应容器大小 */
  background-position: center; /* 背景图居中显示 */
  padding: 40px 50px 50px 50px;
  box-sizing: border-box;
}

.intro-content {
  max-width: 600px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.intro-content h1 {
  font-weight: bold;
  font-size: 32px;
  color: #005cef;
  text-align: center;
  margin-bottom: 24px;
}

.intro-desc {
  padding: 25px;
  background: linear-gradient(180deg, #f4f5fa 0%, #fefeff 100%);
  border-radius: 8px 8px 8px 8px;
  border: 4px solid #ffffff;
  opacity: 0.9;
  margin-bottom: 50px;
  line-height: 1.8;
  color: #000a25;
  font-size: 15px;
  font-weight: 800;
}

.highlight {
  color: #005cef;
  font-weight: 500;
}

/* 优势特点 */
.trial-features {
  display: flex;
  flex-wrap: wrap;
  gap: 45px;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  /* margin-top: 20px; */
}

.feature-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 12px;
}

.feature-text {
  font-weight: 400;
  font-size: 14px;
  color: #2b3139;
}

.client-logo {
  height: 40px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.client-logo:hover {
  opacity: 1;
}

/* 右侧表单区 */
.trial-form-panel {
  width: 50%;
  float: left;
  padding: 20px 27px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.03);
}

.back-btn {
  font-weight: normal;
  font-size: 14px;
  color: #005cef;
  float: right;
  display: flex;
  align-items: center;
  gap: 5px;
}

h2 {
  font-weight: bold;
  font-size: 24px;
  color: #081637;
  text-align: center;
  margin-top: 80px;
}

.form-tip {
  font-weight: normal;
  font-size: 14px;
  color: #000a25;
  margin: 12px 0 31px 0;
  text-align: center;
}

/* 表单样式 */
.trial-form {
  max-width: 440px;
  margin: 0 auto;
}

.el-form-item {
  margin-bottom: 18px;
}

.code-btn {
  width: 110px;
  float: right;
}
.el-button--primary {
  color: #858a9d;
}
.submit-btn {
  width: 100%;
  height: 40px;
  font-size: 16px;
  background: #005cef;
  box-shadow: 0px 6px 24px 1px rgba(0, 92, 239, 0.4);
  border-radius: 4px 4px 4px 4px;
  margin-top: 24px;
}

/* 表单底部 */
.form-footer {
  text-align: center;
  margin-top: 30px;
  margin-top: 55px;
}

.form-footer p {
  color: #999;
  font-size: 14px;
  margin: 0 0 15px;
}

.trial-form-panel2 {
  width: 50%;
  float: left;
  padding: 20px 27px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.03);
  text-align: center;
  min-height: 300px; /* 可根据实际调整 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.error {
  box-shadow: 0px 0px 99px 1px rgba(8, 43, 125, 0.16);
  border-radius: 8px 8px 8px 8px;
}
.success-icon {
  width: 64px;
  height: 64px;
  margin-top: 178px;
  margin-bottom: 32px;
}
.success-icon .checkimg {
  width: 100%;
  height: 100%;
}
.account-info {
  margin-bottom: 30px;
}

.account-info p {
  font-weight: bold;
  font-size: 16px;
  color: #005cef;
}

.account-info .expire-tip {
  font-weight: 400;
  font-size: 14px;
  color: #858a9d;
  margin-top: 16px;
}
.expire-tips {
  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 20px;
  margin-left: 60px;
}
.btn-group {
  display: flex;
  gap: 20px;
  margin-top: 53px;
}

.btn-group button {
  padding: 10px 24px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.login-btn {
  width: 160px;
  height: 40px;
  background: #005cef;
  color: #ffffff;
  border-radius: 4px 4px 4px 4px;
  display: flex;
  gap: 30px;
  align-items: center;
  justify-content: center;
}
.login-btn .arrow {
  /* 补充箭头样式（如白色圆圈） */
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  margin-left: 8px;
  display: inline-block;
}
.home-btn {
  width: 160px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #005cef;
  color: #005cef;
  display: flex;
  gap: 30px;
  align-items: center;
  justify-content: center;
}
.home-btns {
  width: 160px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #005cef;
  color: #005cef;
  display: flex;
  gap: 30px;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.home-btn .arrow {
  /* 补充箭头样式（如白色圆圈） */
  width: 16px;
  height: 16px;
  border: 2px solid #005cef;
  border-radius: 50%;
  margin-left: 8px;
  display: inline-block;
}
.home-btns .arrow {
  /* 补充箭头样式（如白色圆圈） */
  width: 16px;
  height: 16px;
  border: 2px solid #005cef;
  border-radius: 50%;
  margin-left: 8px;
  display: inline-block;
}
/* 响应式适配 */
@media (max-width: 1200px) {
  .trial-intro,
  .trial-form-panel {
    padding: 40px 50px;
  }
}

@media (max-width: 992px) {
  .trial-container {
    flex-direction: column;
  }

  .trial-intro {
    padding: 40px 30px;
  }

  .trial-form-panel {
    padding: 40px 30px;
    box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.03);
  }

  .trial-form {
    max-width: 100%;
  }
}

@media (max-width: 576px) {
  .intro-content h1 {
    font-size: 28px;
  }

  .trial-features {
    gap: 20px;
  }

  .feature-item {
    min-width: 120px;
  }
}
</style>
